/*
 * サブシステム名：マスタ管理
 * 機能名：定型コース一覧
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstTeikeiCorceList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      ninushiCd: '',
      chumonNo: '',
      seikyuShashuSbt: '',
      keiyakuSbt: '',
      unkoSbt: '',
      tantoEigyoshoCd: '',
      kamotsuKbn: '',
      hacchusakiCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },

    /*
    headersTorihikisakiList: [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ],
    */
    mstEigyoshoHeader: header.mstEigyoshoHeaders,
    mstTorihikisakiHeader: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdCodeTextBox,
    DdDataTable,
    DdDefaultButton,
    DdDropDown,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdSwitch,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.ninushiId) { elem.ninushiDisp = elem.ninushiCd + ' : ' + elem.ninushiNm }
        if (elem.hatsuchiId) { elem.hatsuchiDisp = elem.hatsuchiCd + ' : ' + elem.hatsuchiNm }
        if (elem.chakuchiId) { elem.chakuchiDisp = elem.chakuchiCd + ' : ' + elem.chakuchiNm }
        if (elem.keiyuchiId1) { elem.keiyuchiId1Disp = elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm }
        if (elem.keiyuchiId2) { elem.keiyuchiId2Disp = elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm }
        if (elem.keiyuchiId3) { elem.keiyuchiId3Disp = elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm }
        if (elem.keiyuchiId4) { elem.keiyuchiId4Disp = elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm }
        if (elem.keiyuchiId5) { elem.keiyuchiId5Disp = elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm }
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        if (elem.hacchusakiId) { elem.hacchusakiDisp = elem.hacchusakiCd + ' : ' + elem.hacchusakiNm }
        if (elem.hatsuchiHms) { elem.hatsuchiHms = (elem.hatsuchiHms).slice(0, 5) }
        if (elem.chakuchiHms) { elem.chakuchiHms = (elem.chakuchiHms).slice(0, 5) }
        if (elem.seikyuKihonUnchin) { elem.seikyuKihonUnchin = filter.numericFormatter(elem.seikyuKihonUnchin) }
        if (elem.seikyuTsukoryo) { elem.seikyuTsukoryo = filter.numericFormatter(elem.seikyuTsukoryo) }
        if (elem.seikyuKingaku1) { elem.seikyuKingaku1 = filter.numericFormatter(elem.seikyuKingaku1) }
        if (elem.seikyuKingaku2) { elem.seikyuKingaku2 = filter.numericFormatter(elem.seikyuKingaku2) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.shiharaiKihonUnchin) { elem.shiharaiKihonUnchin = filter.numericFormatter(elem.shiharaiKihonUnchin) }
        if (elem.shiharaiTsukoryo) { elem.shiharaiTsukoryo = filter.numericFormatter(elem.shiharaiTsukoryo) }
        if (elem.shiharaiKingaku1) { elem.shiharaiKingaku1 = filter.numericFormatter(elem.shiharaiKingaku1) }
        if (elem.shiharaiKingaku2) { elem.shiharaiKingaku2 = filter.numericFormatter(elem.shiharaiKingaku2) }
        if (elem.shiharaiGokei) { elem.shiharaiGokei = filter.numericFormatter(elem.shiharaiGokei) }
        elem.startLockFlgDisp = elem.startLockFlg ? '〇' : ''
        elem.endLockFlgDisp = elem.endLockFlg ? '〇' : ''
        elem.hacchusakiFlgDisp = elem.hacchusakiFlg ? '〇' : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      shubetsuList: 'DDMasters/mstShubetsu'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 契約種別フィルター
    filteredKeiyakuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBTC04')
    },
    // 運行種別フィルター
    filteredUnkoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBTC02')
    },
    // 貨物区分フィルター
    filteredKamotsuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT025')
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'msthacchakuchi', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstTeikeiList.defineHeaderPromise')
            self.headers = [
              { text: 'コースNo', value: 'teikeiCourseNo' },
              { text: 'コース名称', value: 'teikeiCourseNm' },
              { text: '顧客名称', value: 'ninushiDisp' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '車種', value: 'seikyuShashuSbtNm' },
              /*
              { text: '契約種別', value: 'keiyakuSbtNm' },
              { text: '運行種別', value: 'unkoSbtNm' },
              { text: '運行間隔', value: 'unkoKankakuSbtNm' },
              { text: '作業日備考', value: 'sagyoYoteiBiko' },
              */
              { text: '担当営業所', value: 'tantoEigyoshoDisp' },
              { text: '貨物区分', value: 'kamotsuKbnNm' },
              { text: '発注先', value: 'hacchusakiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発時刻', value: 'hatsuchiHms' },
              { text: '発時刻指定', value: 'startLockFlgDisp' },
              /*
              { text: '接車時刻', value: 'hatsuchiHmsBiko' },
              */
              { text: '経由地１', value: 'keiyuchiId1Disp' },
              { text: '経由地２', value: 'keiyuchiId2Disp' },
              { text: '経由地３', value: 'keiyuchiId3Disp' },
              { text: '経由地４', value: 'keiyuchiId4Disp' },
              { text: '経由地５', value: 'keiyuchiId5Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着時刻', value: 'chakuchiHms' },
              { text: '着時刻指定', value: 'endLockFlgDisp' },
              { text: '請求運賃計算方法区分', value: 'seikyuUnchinKeisanKbnNm' },
              { text: '請求運賃', value: 'seikyuKihonUnchin', align: 'end' },
              { text: '請求有料代', value: 'seikyuTsukoryo', align: 'end' },
              { text: '請求立替金', value: 'seikyuKingaku1', align: 'end' },
              { text: '請求貨物保険料', value: 'seikyuKingaku2', align: 'end' },
              { text: '請求合計', value: 'seikyuGokei', align: 'end' },
              /*
              { text: '支払運賃計算方法区分', value: 'shiharaiUnchinKeisanKbnNm' },
              { text: '支払運賃', value: 'shiharaiKihonUnchin', align: 'end' },
              { text: '支払有料代', value: 'shiharaiTsukoryo', align: 'end' },
              { text: '支払立替金', value: 'shiharaiKingaku1', align: 'end' },
              { text: '支払貨物保険料', value: 'shiharaiKingaku2', align: 'end' },
              { text: '支払合計', value: 'shiharaiGokei', align: 'end' },
              */
              { text: '配車備考', value: 'haishaBiko' },
              { text: 'その他連絡', value: 'renrakuBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          self.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTeikeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTeikeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTeikeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstTeikeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2mstd0370/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
                seikyuShashuSbt: self.conditions.seikyuShashuSbt,
                keiyakuSbt: self.conditions.keiyakuSbt,
                unkoSbt: self.conditions.unkoSbt,
                kamotsuKbn: self.conditions.kamotsuKbn
              }
            })
        },
        getSavedInputMethod: function () {
          return {
            seikyuShashuSbt: self.conditions.seikyuShashuSbt ?? '',
            keiyakuSbt: self.conditions.keiyakuSbt ?? '',
            unkoSbt: self.conditions.unkoSbt ?? '',
            kamotsuKbn: self.conditions.kamotsuKbn ?? ''
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
      this.Effects.loadComplete()
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .post('/api/v1/VwCD2mstd0370/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        teikeiCourseNo: '',
        teikeiCourseNm: '',
        ninushiCd: '',
        chumonNo: '',
        seikyuShashuSbt: '',
        keiyakuSbt: '',
        unkoSbt: '',
        tantoEigyoshoCd: '',
        kamotsuKbn: '',
        hacchusakiCd: '',
        hatsuchiCd: '',
        chakuchiCd: ''
      }
      this.searchText = ''
      this.rows = []
    }
  }
}
